import { Coords } from '@energy-stacks/fleet/shared';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { jobsMarkerStyles } from './jobsMarkerStyles';

type PoolJobsClusterProps = Coords & {
  productTypes: string[];
  onClick?: () => void;
};

export const PoolJobsCluster: React.FC<PoolJobsClusterProps> = ({
  productTypes,
  onClick,
}) => {
  const isMixed = useMemo(() => {
    return (
      productTypes.some((type) => type === 'raw') &&
      productTypes.some((type) => type === 'degassed')
    );
  }, [productTypes]);

  let icon = null;

  const productsCount = productTypes.length;
  const digits = productsCount.toString().length;
  const width = 40 + digits * 8;
  const height = 34;

  if (isMixed) {
    icon = (
      <>
        <g transform={`translate(${width - 55})`}>
          <circle
            cx="40.3876"
            cy={height / 2}
            r="6.75"
            fill="url(#paint0_linear_12391_36802)"
            stroke="white"
            strokeWidth="1.5"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_12391_36802"
            x1="34.3876"
            y1="18"
            x2="46.3876"
            y2="18"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.490285" stopColor="#C78F00" />
            <stop offset="0.490385" stopColor="white" />
            <stop offset="0.514423" stopColor="#00ADC7" />
          </linearGradient>
        </defs>
      </>
    );
  } else if (productTypes[0] === 'raw') {
    // Safe to check first element since at this point there will only be one product type in productTypes array
    icon = (
      <circle
        cx={width - 13}
        cy={height / 2}
        r="5.75"
        fill="#00ADC7"
        stroke="white"
        strokeWidth="1.5"
      />
    );
  } else {
    icon = (
      <circle
        cx={width - 13}
        cy={height / 2}
        r="5.75"
        fill="#C78F00"
        stroke="white"
        strokeWidth="1.5"
      />
    );
  }

  return (
    <Box onClick={onClick} sx={jobsMarkerStyles}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
      >
        <rect
          x="1.0775"
          y="0.828963"
          width={width - 2}
          height="31"
          rx="15.5"
          transform="rotate(1 1.0775 0.828963)"
          fill="white"
        />
        <rect
          x="1.0775"
          y="0.828963"
          width={width - 2}
          height="31"
          rx="15.5"
          transform="rotate(1 1.0775 0.828963)"
          stroke="#29314F"
        />
        <text
          transform="translate(6.48035 6.46094) rotate(1)"
          fill="#29314F"
          fontFamily="Poppins"
          fontSize="14"
          fontWeight="500"
          letterSpacing="0em"
        >
          <tspan x="0.0859375" y="14.9">
            +{productsCount}
          </tspan>
        </text>
        {icon}
      </svg>
    </Box>
  );
};
